var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStreamColor(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "190px",
    height: "150px",
    viewBox: "0 0 190 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "StreamColor") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "1.05104327e-07%",
    y1: "21.4220469%",
    x2: "99.999575%",
    y2: "27.0255672%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9768A6",
    offset: "14.0625%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8786C9",
    offset: "53.6458313%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5771B8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M144.916446,59.5803998 C145.166689,56.8385256 143.720139,54.4036044 140.658709,52.3224444 C137.158904,49.9532346 133.60779,47.6146301 129.932454,45.3354359 C124.193961,41.7825213 118.423963,38.2584118 112.519842,34.8018139 C106.20795,31.0976732 99.7925405,27.4538429 93.3051184,23.8523199 C87.4937132,20.6297625 81.5787901,17.4666154 75.6422633,14.3160705 C73.3405651,13.0954593 70.9659544,11.8928513 68.4041113,10.8594726 C63.8844295,9.03125636 58.8642612,8.49116294 53.5317388,9.51283966 C50.2497711,10.144749 47.1982433,11.0890123 44.5319821,12.3402287 C40.0420055,14.4510938 35.5637309,16.56826 31.3861083,18.8717585 C23.261303,23.3464324 15.2814227,27.9048209 8.1674922,32.9384916 C5.50033086,34.8144161 3.13562184,36.7938584 1.42712632,39.0298452 C0.443256144,40.335071 -0.0167234184,41.6258942 0.0219832767,42.9014149 C0.066090906,44.3551663 -0.0509293349,75.2557112 0.0282843666,76.5780399 C0.112899002,77.9822828 0.800617957,79.3685226 2.06083594,80.7340587 C4.03937816,82.8620268 6.74704651,84.7019451 9.56903462,86.4752518 C14.4118723,89.5240792 19.2961171,92.5369003 24.232571,95.5308181 C29.1996301,98.5436393 34.2513039,101.507852 39.2597702,104.495469 C39.2804738,104.483767 39.3011774,104.472065 39.3434847,104.472065 C40.7909351,105.307409 42.2275836,106.161657 43.7065394,106.9898 C47.0497176,108.872926 50.382094,110.773155 53.7981849,112.624775 C59.3386432,115.618693 64.910607,118.60721 70.5338797,121.553419 C72.5439274,122.605701 74.6268876,123.63998 76.8763767,124.50503 C81.3339478,126.225227 86.2190927,126.723914 91.394988,125.742744 C94.7084611,125.118036 97.7905943,124.179173 100.467657,122.910854 C105.197075,120.673067 109.937295,118.418177 114.352559,115.976055 C121.613215,111.964961 128.780255,107.898957 135.196564,103.412581 C137.77101,101.614971 140.415667,99.8461646 142.260086,97.7479016 C143.561711,96.2860488 144.759818,94.7890898 144.916446,93.1111996 C145.166689,90.3693254 144.759818,61.25829 144.916446,59.5803998",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-20.7%",
    y: "-25.6%",
    width: "141.4%",
    height: "151.2%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 10,
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-26.6%",
    y: "-32.8%",
    width: "153.1%",
    height: "165.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-4"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M140.658709,43.3208871 C137.158904,40.9516773 133.60779,38.6130728 129.932454,36.3338786 C124.193961,32.7809641 118.423963,29.2568545 112.519842,25.8002566 C106.20795,22.0961159 99.7925405,18.4522856 93.3051184,14.8507627 C87.4937132,11.6282053 81.5787901,8.46505815 75.6422633,5.3145132 C73.3405651,4.09390207 70.9659544,2.89129406 68.4041113,1.85791531 C63.8844295,0.0296990893 58.8642612,-0.51039433 53.5317388,0.511282388 C50.2497711,1.14319169 47.1982433,2.08745502 44.5319821,3.33867144 C40.0420055,5.44953656 35.5637309,7.56670276 31.3861083,9.8702012 C23.261303,14.3448752 15.2814227,18.9032636 8.1674922,23.9369343 C5.50033086,25.8128588 3.13562184,27.7923012 1.42712632,30.0282879 C0.443256144,31.3335137 -0.0167234184,32.624337 0.0219832767,33.8998576 C0.066090906,35.353609 -0.0509293349,66.2541539 0.0282843666,67.5764826 C0.112899002,68.9807255 0.800617957,70.3669653 2.06083594,71.7325015 C4.03937816,73.8604696 6.74704651,75.7003878 9.56903462,77.4736945 C14.4118723,80.5225219 19.2961171,83.535343 24.232571,86.5292609 C29.1996301,89.542082 34.2513039,92.5062947 39.2597702,95.4939115 C39.2804738,95.4822095 39.3011774,95.4705074 39.3434847,95.4705074 C40.7909351,96.3058519 42.2275836,97.1600997 43.7065394,97.9882429 C47.0497176,99.8713686 50.382094,101.771597 53.7981849,103.623218 C59.3386432,106.617135 64.910607,109.605652 70.5338797,112.551862 C72.5439274,113.604144 74.6268876,114.638423 76.8763767,115.503473 C81.3339478,117.22367 86.2190927,117.722356 91.394988,116.741187 C94.7084611,116.116479 97.7905943,115.177616 100.467657,113.909297 C105.197075,111.67151 109.937295,109.41662 114.352559,106.974497 C121.613215,102.963403 128.780255,98.8974002 135.196564,94.4110242 C137.77101,92.6134132 140.415667,90.8446073 142.260086,88.7463444 C143.561711,87.2844915 144.759818,85.7875326 144.916446,84.1096423 C145.166689,81.3677681 144.759818,52.2567328 144.916446,50.5788425 C145.166689,47.8369683 143.720139,45.4020471 140.658709,43.3208871 Z",
    id: "path-5"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-5.9%",
    y: "-7.3%",
    width: "111.7%",
    height: "114.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-6"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.5,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "path-7",
    points: "0.0194986874 0.000173982347 144.943978 0.000173982347 144.943978 83.7082845 0.0194986874 83.7082845"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "4.84848571%",
    y1: "49.4736888%",
    x2: "96.9696952%",
    y2: "49.4736878%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#918ABD",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#878ED1",
    offset: "56.25%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AF81C4",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.4039313,1.85737522 C70.9657744,2.89165412 73.3412853,4.09426213 75.6420832,5.31487326 C81.5786101,8.46541821 87.4935332,11.6285653 93.3049384,14.8511227 C99.7923605,18.4526457 106.20777,22.0955758 112.518762,25.7997165 C118.423783,29.2572146 124.193781,32.780424 129.932274,36.3342387 C133.60851,38.6134329 137.158724,40.9520374 140.658529,43.3212472 C143.719959,45.401507 145.166509,47.8364282 144.916266,50.5792026 C144.759638,52.2561927 143.561531,53.7540518 142.259906,55.2150045 C140.66141,57.0342791 138.461845,58.6047428 136.227844,60.1613686 L135.196384,60.8796843 C128.780074,65.3669604 121.613035,69.4320636 114.352379,73.4431574 C109.937115,75.8852798 105.196895,78.1401698 100.467477,80.378857 C97.7913144,81.6471764 94.7082811,82.5860388 91.394808,83.2107469 C86.2189127,84.1919166 81.3337677,83.6923302 76.8761967,81.9730328 C74.6267076,81.107083 72.5437473,80.0737043 70.5336996,79.0214222 C64.910427,76.0743125 59.3384632,73.0866957 53.798905,70.0927779 C50.3828142,68.2402574 47.0495376,66.3409289 43.7072595,64.4587033 C42.2283037,63.6287598 40.790755,62.7754122 39.3433047,61.9391675 C39.3018975,61.9391675 39.2811939,61.9517697 39.2595902,61.9634717 C34.2511239,58.9749548 29.1994501,56.0107421 24.2323909,52.9988211 C19.2959371,50.0040031 14.4116923,46.9920821 9.56885459,43.9432548 C6.74686648,42.1690479 4.03919813,40.3291297 2.0606559,38.2011616 C-0.385967286,35.5493029 -0.677617733,32.8191307 1.42694629,30.028648 C3.13544181,27.7917611 5.50015083,25.8132188 8.16731217,23.9363942 C15.2812427,18.9036237 23.2611229,14.3443351 31.3859283,9.8696611 C35.5635509,7.56616267 40.0418255,5.44989662 44.5318021,3.3390315 C47.1980633,2.08781508 50.2504913,1.14355175 53.5315588,0.511642451 C58.8640812,-0.510934424 63.8842495,0.0300591516 68.4039313,1.85737522 Z M77.1165383,27.6846425 C68.0231654,32.9352507 59.0441123,38.1192474 49.9921466,43.3446513 C63.2190344,45.7741715 76.3316025,48.1721863 89.5998975,50.6008063 C85.4150737,42.915277 81.2707568,35.3152624 77.1165383,27.6846425 Z",
    id: "path-10"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-1.0%",
    y: "-1.8%",
    width: "102.1%",
    height: "103.6%",
    filterUnits: "objectBoundingBox",
    id: "filter-11"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceAlpha",
    result: "shadowBlurInner1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: -1,
    in: "shadowBlurInner1",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1   0 0 0 0 1   0 0 0 0 1  0 0 0 1 0",
    type: "matrix",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "40.2191165%",
    y1: "46.6292169%",
    x2: "63.0135486%",
    y2: "52.2471952%",
    id: "linearGradient-12"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "17.0391058%",
    y1: "48.0498174%",
    x2: "93.8547498%",
    y2: "51.3001255%",
    id: "linearGradient-13"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A25EBA",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3F5EBF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "StreamColor",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(23.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Glow",
    opacity: 0.8,
    filter: "url(#filter-3)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-4)",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-1"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    fillRule: "evenodd",
    xlinkHref: "#path-5"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-6)",
    xlinkHref: "#path-5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask-8",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Combined-Shape",
    mask: "url(#mask-8)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-9)",
    fillRule: "evenodd",
    xlinkHref: "#path-10"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-11)",
    xlinkHref: "#path-10"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-7",
    fill: "url(#linearGradient-12)",
    points: "77.1164483 27.6846425 77.1164483 48.3162112 89.5998075 50.6008063"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-9",
    fill: "url(#linearGradient-13)",
    points: "77.1164483 27.6846425 77.1164483 48.3162112 49.9920566 43.3446513"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStreamColor);
export default __webpack_public_path__ + "static/media/StreamColor.a2fe073900ee9242012ffda6310edbd3.svg";
export { ForwardRef as ReactComponent };